import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { BambooSecrets_Responsive } from "../BambooSecrets/game_responsive";
export class BambooSecretsLink_Responsive extends BambooSecrets_Responsive {

        constructor(multigameParams: MultigameParams , initData: SlotGameInitData) {
            super(multigameParams , initData, "BambooSecretsLink");
        }
    }
     
